import axios from 'axios';
import encrypt, { versionStatus } from '@/components/plugin/lib/encrypt';
import { ua } from './ua';
import { getSystime } from './getSystime';

function randomString(length = 8) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const array = new Uint32Array(length);
    crypto.getRandomValues(array);

    return Array.from(array, (x) => chars[x % chars.length]).join('');
}

function filterParams(outData, method = 'get') {
  const data= {};
  function isValueValid(value) {
    // 空值直接返回false
    if (value === undefined || value === null || value === '') {
      return false;
    }
    // 非POST请求，且值不是字符串或数字类型，直接返回false
    if (
      method &&
      method.toLowerCase() !== 'post' &&
      !['number', 'string', 'boolean'].includes(typeof value)
    ) {
      return false;
    }
    return true;
  }
  // 处理参数中key为空的情况 例如页面链接为 xxx?&playId=3706
  Object.keys(outData).forEach((key) => {
    if (key) {
      const value = outData[key];
      if (isValueValid(value)) {
        data[key] = value;
      }
    }
  });
  return data;
}

const [platform, os] = ua();

// 创建 axios 实例
const http = axios.create({
  baseURL: '',
  timeout: 30000
});

// 请求拦截器
http.interceptors.request.use(
  async (config) => {
    const extHeaders = {
      Dappost: () => {
        if (platform === "app") {
          return os;
        }
        return "web";
      },
      Dsech: () => {
        if (versionStatus) {
          return "2";
        }
        return "1";
      },
    };

    const commonExtHeaders = ["Dappost", "Dsech"];
    commonExtHeaders.forEach((k) => {
      config.headers[k] = extHeaders[k]();
    });

    // 如果请求已经包含了 sign 或 privateSign，说明已经手动签名过，跳过
    if (config.params && (config.params.sign || config.params.privateSign)) {
      return config;
    }

    config.params = filterParams(config.params);
    config.params.nonce = randomString(36);
    config.params.sTime = await getSystime();

    // 需要签名 → 返回 encrypt 的 promise
    try {
      const signedParams = await encrypt(config.params);
      config.params = signedParams;
      return config;
    } catch (error) {
      console.error('签名失败:', error);
      return config; // 失败也放行
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default http;




// WEBPACK FOOTER //
// ./src/utils/http-interceptor.js